module.exports = __webpack_public_path__ + "img/sponsorR20.30733eb5.png";